// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"66a51ca7","455":"76a35cac","977":"592a3940"}[chunkId] + ".chunk.js";
};